import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';
import { BsTrash } from 'react-icons/bs';

export const Wrapper = styled.form`
  background-color: ${palette('bgInput')};
  border-top: 1px solid ${palette('bgHoverGrey')};
  border-bottom: 1px solid ${palette('bgHoverGrey')};
  margin: 2px 0;
`;

export const ActionItemDeleteIcon = styled(BsTrash)`
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  width: 36px;
  height: 36px;
  opacity: 0;
  transform: scale(0);
  transition: ${theme('transition')};
  cursor: pointer;
`;

export const ActionItem = styled.div<{ error: Error | null }>`
  position: relative;
  display: flex;
  cursor: ${ifProp('disabled', '', 'pointer')};
  color: ${ifProp('disabled', palette('grey'), palette('dark'))};

  font-style: ${ifProp('disabled', 'italic', 'normal')};
  border-left: 8px solid
    ${ifProp('error', palette('danger'), palette('primary'))};
  border-radius: ${theme('borderRadius.sm')} 0 0 ${theme('borderRadius.sm')};
  &:hover ${ActionItemDeleteIcon} {
    opacity: 1;
    transform: scale(1);
  }
  ${theme('components.ActionItem.container')}
`;

export const ErrorText = styled.p`
  color: ${palette('danger')};
  margin: 2px 4px 4px;
`;

export const ActivityInput = styled.input.attrs({
  'data-testid': 'input',
})`
  flex: 1;
  font-family: ${theme('fontFamily')};
  color: ${ifProp(
    'disabled',
    palette('colorActivityInputDisabled'),
    palette('colorActivityInput')
  )};
  display: block;
  margin: 0;
  width: 100%;
  border: none;
  background-color: ${ifProp(
    'readOnly',
    palette('bgActivityInputReadyOnly'),
    palette('bgActivityInput')
  )};
  border-right: ${ifProp('readOnly', '1px', '0')} solid
    ${palette('borderActivityInput')};
  padding: ${ifProp(
    'hasDropdown',
    '10px 10px 10px 38px',
    ifProp('hasIcon', '10px 10px 10px 26px', '10px')
  )};
  outline: none;
  transition: ${theme('transition')};
  border-radius: ${ifProp('readOnly', '0 4px 4px 0', '0')};

  &:focus {
    border-top-color: ${ifProp(
      'readOnly',
      palette('borderActivityInput'),
      palette('primary')
    )};
    border-bottom-color: ${ifProp(
      'readOnly',
      palette('borderActivityInput'),
      palette('primary')
    )};
  }
`;

export const ActivityButton = styled.button`
  display: flex;
  align-items: center;
  background-color: ${palette('primary')};
  font-family: ${theme('fontFamily')};
  color: ${palette('light')};
  padding: 0 ${theme('spacing.md')};
  border: none;
  transition: ${theme('transition')};
  outline: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  ${theme('components.ActionItem.button')}
`;
